import React, { FC } from 'react';

export const CircleTick: FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" {...props}>
    <path fill="#005950" fillRule="evenodd" d="M6 32C6 17.64 17.64 6 32 6s26 11.64 26 26-11.64 26-26 26S6 46.36 6 32m35.628-4.837a2 2 0 0 0-3.255-2.326l-8.628 12.08-4.33-4.331a2 2 0 1 0-2.83 2.828l6 6a2 2 0 0 0 3.043-.252z" clipRule="evenodd"/>
  </svg>
);
    